import { createClient } from '@supabase/supabase-js';
import { env } from './env';

/**
 * The single Supabase browser client.
 *
 * Every privileged write goes through an RPC to a `SECURITY DEFINER` function
 * (CLAUDE.md rule 4) — direct table writes from here are limited to a user's own
 * non-locked columns, and RLS is the backstop, not the gate.
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'crm.auth',
  },
  global: {
    headers: { 'x-application-name': 'real-estate-crm' },
  },
});
